import en_US from './en_US';
import bn_BD from './bn_BD';
export default {
  en_US,
  bn_BD,
};
